// src/bugsnag.tsx
import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// Type for the ErrorBoundary component
type ErrorBoundaryType = React.ComponentType<{ children?: React.ReactNode }>;

// Initialize Bugsnag with your API key
Bugsnag.start({
  apiKey: `${process.env.REACT_APP_BUGSNAG_KEY}`,
  plugins: [new BugsnagPluginReact()],
  enabledBreadcrumbTypes: ["error", "log", "navigation", "request", "user"],
  releaseStage: process.env.REACT_APP_ENV || "production",
  onError: (event) => {
    // Check if event and errors array exist
    event.addMetadata("server", {
      baseURL: process.env.REACT_APP_ENV,
    });
    if (!event?.errors?.length) {
      return;
    }

    // List of error messages to ignore
    const ignoredMessages = [
      "could not retrieve data from the specified Element",
      "Failed to load Stripe.js",
      "We could not retrieve data from the specified Element",
      "stripe.confirmPayment: paymentIntent",
      "stripe.confirmSetup: setupIntent",
      "Invalid value for stripe.confirmPayment: paymentIntent parameter",
      "Invalid value for stripe.confirmSetup: setupIntent parameter",
      "Error Failed to load Stripe.js",
      "did timeout",
    ];

    // Check if any error message matches ignored messages
    const shouldIgnore = event.errors.some((error) => {
      const message =
        error?.errorMessage ??
        (event.originalError instanceof Error
          ? event.originalError.message
          : "");
      if (!message) return false;
      return ignoredMessages.some((msg) => message.includes(msg));
    });

    if (shouldIgnore) {
      return false; // Ignore these errors
    }

    return true; // Report all other errors
  },
  // enabledReleaseStages: [`${process.env.REACT_APP_BUGSNAG_RELEASE_STAGE}`],
  // featureFlags: [
  //   { name: "Checkout button color", variant: "Blue" },
  //   { name: "Special offer", variant: "Free Coffee" },
  //   { name: "New checkout flow" },
  // ],
  // onError: function (event) {
  //   event.setUser("3", "sahil@yopmail.com", "Bugs Nag");
  // },
});

// Get the ErrorBoundary component from Bugsnag's React plugin
const bugsnagReactPlugin = Bugsnag.getPlugin("react");
if (!bugsnagReactPlugin) {
  throw new Error("Bugsnag React plugin not found");
}

const ErrorBoundary: ErrorBoundaryType = bugsnagReactPlugin.createErrorBoundary(
  React
);

export default ErrorBoundary;
